import { Context } from "@nuxt/types";
import { functions, auth } from "~/setups/firebase";
import { NuxtI18nInstance } from "nuxt-i18n";
import { waitForAuthUser } from "~/utils/auth";

export default async function ({
  route,
  from,
  app: { i18n },
  store,
  redirect,
}: Context & { app: { i18n: NuxtI18nInstance } }) {
  // simple server guard to prevent SSR calls (for bug-157)
  if (process.server) return;
  // bail early to lower workload
  if (from && route.path === from.path) return

  // Exclude login page (including localized versions like /zhTw/login)
  const isLoginPage =
    /^\/[a-z]{2,4}\/login\/?$/.test(route.path) ||
    /^\/login\/?$/.test(route.path) ||
    route.name === "login" ||
    route.name === "zhTw-login" ||
    route.name === "ja-login" ||
    route.path.includes("/login");

  if (isLoginPage) {
    return;
  }

  // wait for firebase auth to restore session when refreshing page
  const user = auth.currentUser || (await waitForAuthUser(auth))

  // dont do ip check if no user
  if (!user) return

  if (!store.getters["auth/isLoggedIn"]) await store.dispatch("auth/setUser", user)

  try {
    const res = await functions.httpsCallable("checkIpAddress")()
    return res.data
  } catch (error) {
    console.error("Error checking IP address:", error)

    if (error.code === "functions/unauthenticated") {
      // retry once just in case
      const user = auth.currentUser
      if (user) {
        await user.getIdToken(true)
        const res2 = await functions.httpsCallable("checkIpAddress")()
        return res2.data
      }
      // token still not ready and/or transient, DO NOT boot to login in this block
      return
    }

    alert(i18n.t("app.login.ipRestrictedError"))
    store.dispatch("auth/setSuperadmin", false)
    await store.dispatch("auth/logout")

    return redirect({path: "/login", query: {from: route.fullPath}})
  }
}
